import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineSmallButton, PrimaryButton,} from "../../../../Constant";
import { SMALL_OUTLINE_BUTTONS, SMALL_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/DefaultStyle";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonButton from "../Common/CommonButton";

const OutlineSmallButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={OutlineSmallButton} span={SMALL_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="sm" outline color="primary" id="Tooltip-61">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-61" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-outline-primary btn-sm</ToolTip>
          {SMALL_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonButton key={index} item={data} outline={true} size="sm"/>
          ))}
        </CardBody>
      </Card>
    );
};

export default OutlineSmallButtons;
